import type { SiteId } from './api/types';
import { tk } from './i18n';

/**
 * La marca de este dashboard. Se elige al compilar: `vite build` hace el de MTX (dist/) y
 * `vite build --mode pm` el de Phelon & Moore (dist-pm/). Los dos hablan con la misma API, que
 * les da a cada uno solo lo suyo (cada uno manda su marca en cada petición).
 */
export const SITE: SiteId = import.meta.env.VITE_SITE === 'phelon-moore' ? 'phelon-moore' : 'mtx';

export const SITE_LABELS: Record<SiteId, string> = { mtx: 'MTX', 'phelon-moore': 'Phelon & Moore' };

interface Brand {
  /** "MTX", "Phelon & Moore" */
  name: string;
  /** Lo que se administra aquí (debajo del logo, en la página de entrada). Se traduce con t() al mostrarlo. */
  tagline: string;
  /** La otra marca (para los accesos de los usuarios que entran a las dos). */
  other: SiteId;
}

export const BRAND: Brand =
  SITE === 'phelon-moore'
    ? { name: 'Phelon & Moore', tagline: tk('Noticias, historia y mensajes de la landing.'), other: 'mtx' }
    : { name: 'MTX', tagline: tk('Motos, puntos de venta, textos y mensajes del sitio.'), other: 'phelon-moore' };
